(function () {
	'use strict';

	angular
		.module('cacmConcurExpenseModule', []);
})();